import React from "react";
import Lottie from "react-lottie";
import notFound from "../lotties/notFound.json";

const Error404 = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div
      style={{
        display: "flex",
        marginTop: 120,
        padding: 10,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Lottie
        options={{
          ...defaultOptions,
          animationData: notFound,
        }}
        height={100}
        width={100}
      />
      <h2 style={{ textAlign: "center" }}>
        Error 404. <p>Lo sentimos, no encontramos lo que buscas.</p>
      </h2>
    </div>
  );
};

export default Error404;
